<template>
  <div class="video-list-page">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <h1 class="page-title">历史视频</h1>
    </div>

    <!-- 视频列表 -->
    <div class="video-list-container">
      <van-loading v-if="loading" size="24px" class="loading-indicator" />

      <div v-else-if="videoList.length > 0" class="video-list">
        <div
          v-for="(video, index) in videoList"
          :key="index"
          class="video-item"
          @click="playVideo(video)"
        >
          <div class="video-thumbnail">
            <video
              :src="video.url"
              preload="metadata"
              class="thumbnail-video"
            ></video>
            <div class="play-icon">
              <van-icon name="play" size="32" color="#fff" />
            </div>
            <!-- <div class="video-duration" v-if="video.duration">
              {{ formatDuration(video.duration) }}
            </div> -->
          </div>
          <!-- <div class="video-info">
            <div class="video-title">
              {{ video.title || `视频 ${index + 1}` }}
            </div>
            <div class="video-date" v-if="video.date">{{ video.date }}</div>
          </div> -->
        </div>
      </div>

      <van-empty v-else description="暂无视频" class="empty-content" />
    </div>

    <!-- 视频播放蒙层 -->
    <van-popup
      v-model="showVideoPlayer"
      position="center"
      :close-on-click-overlay="false"
      :overlay="true"
      :closeable="false"
      class="video-popup"
      @close="onPopupClose"
    >
      <div class="video-player-wrapper">
        <div class="video-header">
          <div class="video-title-text">
            <!-- {{ currentVideo.title || "视频播放" }} -->
            历史视频
          </div>
          <van-icon name="cross" class="close-icon" @click="closeVideoPlayer" />
        </div>
        <div class="video-content">
          <video
            ref="videoPlayer"
            :src="currentVideo.url"
            controls
            autoplay
            playsinline
            webkit-playsinline
            class="video-player"
            @loadedmetadata="onVideoLoaded"
          ></video>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "VideoList",
  data() {
    return {
      loading: false,
      personPrivilgeId: this.$route.query.personPrivilgeId || "",
      showVideoPlayer: false,
      currentVideo: {
        url: "",
        title: "",
      },
      videoList: [
        {
          url: "https://morehealthy.oss-cn-beijing.aliyuncs.com/cunchuguan/cunchuguan.mp4",
          title: "视频1",
          date: "2024-01-15",
          duration: 120,
        },
        {
          url: "https://morehealthy.oss-cn-beijing.aliyuncs.com/cunchuguan/cunchuguan2.mp4",
          title: "视频2",
          date: "2024-01-14",
          duration: 180,
        },
        {
          url: "https://morehealthy.oss-cn-beijing.aliyuncs.com/cunchuguan/cunchuguan3.mp4",
          title: "视频3",
          date: "2024-01-14",
          duration: 180,
        },
      ],
    };
  },
  mounted() {
    this.loadVideoList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async loadVideoList() {
      this.loading = true;
      // TODO: 根据 personPrivilgeId 从API加载视频列表
      // const response = await getVideoList({ personPrivilgeId: this.personPrivilgeId });
      // if (response.code === 200) {
      //   this.videoList = response.data || [];
      // }

      // 模拟加载延迟
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    playVideo(video) {
      this.currentVideo = {
        url: video.url,
        title: video.title || "",
      };
      this.showVideoPlayer = true;
    },
    closeVideoPlayer() {
      this.showVideoPlayer = false;
      this.stopVideo();
    },
    onPopupClose() {
      this.stopVideo();
    },
    stopVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    onVideoLoaded() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.volume = 1;
        video.muted = false;
        video.play().catch((error) => {
          console.log("自动播放失败，可能需要用户交互", error);
        });
      }
    },
    formatDuration(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped lang="less">
.video-list-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.header-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.back-icon {
  position: absolute;
  left: 16px;
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

/* 视频列表容器 */
.video-list-container {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}

.empty-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* 视频列表 */
.video-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* 视频项 */
.video-item {
  background: white;
  // border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.video-item:active {
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 视频缩略图 */
.video-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 宽高比 */
  background: #000;
  overflow: hidden;
}

.thumbnail-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.video-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
}

/* 视频信息 */
.video-info {
  padding: 12px 15px;
}

.video-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.video-date {
  font-size: 13px;
  color: #999;
}

/* 视频播放蒙层 */
::v-deep .video-popup {
  background: transparent !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  border-radius: 0 !important;
}

::v-deep .video-popup .van-popup {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  left: 0 !important;
  top: 0 !important;
  transform: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.video-player-wrapper {
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0;
  padding: 0;
}

.video-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.video-title-text {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 15px;
}

.close-icon {
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
}

.video-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
</style>
